var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"notification-icon-wrapper"},[_c('div',{staticClass:"icon"},[_c(_vm.handleIconSelection.icon,{tag:"Component",attrs:{"color":_vm.handleIconSelection.color}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }